/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPlanQuery } from '../../models/get-plan-query';
import { GetPlanQueryResult } from '../../models/get-plan-query-result';

export interface ApiPlanGetPlanPost$Plain$Params {
  
    /**
     * Plan query parameters
     */
    body?: GetPlanQuery
}

export function apiPlanGetPlanPost$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanGetPlanPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlanQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanGetPlanPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPlanQueryResult>;
    })
  );
}

apiPlanGetPlanPost$Plain.PATH = '/api/Plan/GetPlan';
